import {
    addDays,
    addHours,
    addMilliseconds,
    addMinutes,
    addMonths,
    addSeconds,
    addYears,
    startOfDay,
    startOfHour,
    startOfMinute,
    startOfMonth,
    startOfSecond,
    startOfYear,
    subDays,
    subHours,
    subMilliseconds,
    subMinutes,
    subMonths,
    subSeconds,
    subYears,
} from 'date-fns';
import { Duration } from '../Utils/Duration';

// TODO add more TimeUnits as needed
export type TimeUnit =
    | 'year'
    | 'years'
    | 'month'
    | 'months'
    | 'day'
    | 'days'
    | 'hour'
    | 'hours'
    | 'minute'
    | 'minutes'
    | 'second'
    | 'seconds';

export function startOf(date: number | Date, unit: TimeUnit): Date {
    switch (unit) {
        case 'second':
            return startOfSecond(date);
        case 'minute':
            return startOfMinute(date);
        case 'hour':
            return startOfHour(date);
        case 'day':
            return startOfDay(date);
        case 'month':
            return startOfMonth(date);
        case 'year':
            return startOfYear(date);
        default:
            throw new Error('Invalid unit');
    }
}

export function addUnitsOfTime(date: number | Date, amount: number, unit: TimeUnit): Date {
    switch (unit) {
        case 'second':
        case 'seconds':
            return addSeconds(date, amount);
        case 'minute':
        case 'minutes':
            return addMinutes(date, amount);
        case 'hour':
        case 'hours':
            return addHours(date, amount);
        case 'day':
        case 'days':
            return addDays(date, amount);
        case 'month':
        case 'months':
            return addMonths(date, amount);
        case 'year':
        case 'years':
            return addYears(date, amount);
        default:
            throw new Error('Invalid unit');
    }
}

export function subUnitsOfTime(date: number | Date, amount: number, unit: TimeUnit): Date {
    switch (unit) {
        case 'second':
        case 'seconds':
            return subSeconds(date, amount);
        case 'minute':
        case 'minutes':
            return subMinutes(date, amount);
        case 'hour':
        case 'hours':
            return subHours(date, amount);
        case 'day':
        case 'days':
            return subDays(date, amount);
        case 'month':
        case 'months':
            return subMonths(date, amount);
        case 'year':
        case 'years':
            return subYears(date, amount);
        default:
            throw new Error('Invalid unit');
    }
}

export function subDurationFromDate(date: Date, duration: Duration) {
    return subMilliseconds(date, duration.valueOf());
}

export function addDurationToDate(date: Date, duration: Duration) {
    return addMilliseconds(date, duration.valueOf());
}
